// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_it-a";
export var fulfillmentFormRail = "_it-9";
export var headerTitleRow = "_it-c";
export var orderDetailsWrapper = "_it-7";
export var orderLinkTrigger = "_it-2";
export var paymentInformationGrid = "_it-h";
export var paymentSummaryColumn = "_it-i";
export var shipmentContainer = "_it-b";
export var shipmentDetailsMainPane = "_it-8";
export var shipmentNavigationCard = "_it-5";
export var shipmentNavigationRail = "_it-3";
export var shipmentNavigationRailHeader = "_it-4";
export var shipmentSummaryFact = "_it-e";
export var shipmentSummaryGrid = "_it-d";
export var shipmentSummaryMetadataRow = "_it-f";
export var shipmentSummaryTags = "_it-g";
export var shipmentWorkspace = "_it-0";
export var shipmentWorkspaceContent = "_it-6";
export var shipmentWorkspaceHeader = "_it-1";